import React from 'react';
import { PricingAccountRow } from '@sales-portal/domain/pricing/screens/management/blocs/transformers/use-pricing-management-transformers';
import { PricingItemDetailsTableRow } from '@sales-portal/domain/pricing/screens/management/components/pricing-item-details-table-row';
import { Row, VisibilityState } from '@tanstack/react-table';
import {
  selectPriceEdit,
  usePricingEditsStore,
} from '@sales-portal/domain/pricing/blocs/stores/pricing-edits-store';

interface Props<T extends PricingAccountRow> {
  columnOrder?: string[];
  columnVisibility?: VisibilityState;
  hasGreyBackground?: boolean;
  index: number;
  isSelected: boolean;
  row: Row<T>;
}

// Reads the row's edit flag from the store so the screen's renderRow doesn't
// depend on the edits array and re-render every row on each edit.
export const PricingItemDetailsTableRowContainer = <
  T extends PricingAccountRow,
>({
  columnOrder,
  columnVisibility,
  hasGreyBackground,
  index,
  isSelected,
  row,
}: Props<T>) => {
  const { restaurantUUID, variantPackUUID } = row.original;
  const hasChanges = usePricingEditsStore(
    (state) =>
      selectPriceEdit(state, variantPackUUID, restaurantUUID) !== undefined,
  );

  return (
    <PricingItemDetailsTableRow
      columnOrder={columnOrder}
      columnVisibility={columnVisibility}
      hasChanges={hasChanges}
      hasGreyBackground={hasGreyBackground}
      index={index}
      isSelected={isSelected}
      row={row}
    />
  );
};
